<style lang="scss" scoped>
>>> .v--modal {
  background-color: transparent !important;
}

.close-button {
  width: 38px;
  height: calc(100% - 2px);
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 1px;
  right: 0;
}

.profile-search-input-wrapper {
  position: relative;
}

.profile-search-input {
  padding-right: 45px;
  border-left: 0;
  border-right: 0;
  min-width: 0;
  flex-grow: 0;
  border-radius: 15px;
  margin: 5px;
  height: 32px;

  &::placeholder {
    color: #c5c5c5;
  }
}

.profile-image {
  width: 45px;
}

.customer-list-wrapper {
  max-height: calc(100vh - 102px);
  overflow-y: auto;
}

.profile-name-wrapper {
  display: flex;
  align-items: center;
  word-break: break-all;
  word-break: break-word;
}

.online-circle {
  margin-right: 10px;
}

.profile-search-modal::v-deep .v--modal-box {
  top: 40px !important;
  max-height: calc(100vh - 60px);
}

.profile-search-navbar {
  display: none;
  width: 90vw;
  max-width: 600px;
  position: fixed;
  top: 3px;
  left: 50%;
  transform: translateX(-50%);
}

@media only screen and (min-width: 1500px) {
  .search-button {
    display: none;
  }

  .profile-search-navbar {
    display: block;
  }

  .profile-search-modal::v-deep .v--modal-box {
    top: 3px !important;
  }
}

.form-control {
  width: 99%;
}
</style>

<template>
  <div>
    <button
      @click="showSearchModal"
      class="btn btn-outline-secondary m-auto search-button"
      type="button"
    >
      <span class="d-none d-sm-inline">Schnellsuche </span
      ><i class="fa fa-search"></i>
    </button>
    <div class="profile-search-input-wrapper profile-search-navbar">
      <input
        class="form-control profile-search-input d-lg-inline"
        type="search"
        placeholder="Mitgliedername suchen"
        v-model="searchInput"
        @click="showSearchModal"
      />
    </div>
    <modal
      class="profile-search-modal"
      :maxWidth="600"
      width="90%"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      style="overflow: hidden"
      name="profile-search"
      @opened="$refs.input.focus()"
    >
      <div class="profile-search-input-wrapper">
        <input
          class="form-control profile-search-input"
          type="search"
          placeholder="Mitgliedername suchen"
          v-model="searchInput"
          @input="onInput"
          ref="input"
        />
        <button
          type="button"
          class="btn close-button"
          @click="$modal.hide('profile-search')"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="customer-list-wrapper">
        <ul class="list-group list-group-flush">
          <li
            v-if="loading"
            class="list-group-item d-flex justify-content-center align-items-center"
          >
            <i class="fas fa-spinner fa-pulse fa-2x"></i>
          </li>
          <a
            v-else
            v-for="customerProfile in customerProfiles"
            :key="customerProfile.id"
            :href="customerProfile.url"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
          >
            <div class="profile-name-wrapper">
              <online-circle
                class="online-circle"
                :id="customerProfile.id"
              ></online-circle>
              {{ customerProfile.name }}
            </div>
            <div class="pl-3">
              <img
                class="profile-image rounded-circle"
                :src="`${customerProfile.primary_image.url}?width=45&height=45`"
              />
            </div>
          </a>
        </ul>
      </div>
    </modal>
  </div>
</template>
<script>
import { debounce } from "lodash";
import OnlineCircle from "@/components/OnlineCircle";

export default {
  components: {
    OnlineCircle
  },
  data() {
    return {
      searchInput: "",
      customerProfiles: [],
      searchDebounced: debounce(this.search, 150),
      minLength: 3,
      loading: false
    };
  },
  methods: {
    onInput() {
      if (this.searchInput.length < this.minLength) {
        this.loading = false;
        this.searchDebounced.cancel();
        this.customerProfiles = [];
        return;
      }
      this.loading = true;
      this.searchDebounced();
    },
    showSearchModal() {
      this.$modal.show("profile-search");
    },
    search() {
      let enteredSearchInput = this.searchInput;
      this.$http
        .get("/api/v1/customerProfile", {
          params: {
            filter: [
              {
                name: "where",
                attributes: {
                  name: {
                    operator: "like",
                    value: "%" + enteredSearchInput + "%"
                  },
                  user_id: {
                    operator: "!=",
                    value: this.$store.getters["user/me"].id
                  }
                }
              },
              {
                name: "take",
                value: 20
              }
            ]
          }
        })
        .then(({ data }) => {
          if (enteredSearchInput === this.searchInput) {
            this.customerProfiles = data;
            this.loading = false;
          }
        });
    }
  }
};
</script>
